import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    isProvinceLoading: false,
    isCantonLoading: false,
    isDistrictLoading: false,
    isCustomerTypeLoading: false,
    isCategoryTypeLoading: false,
    province: [],
    canton: [],
    district: [],
    customerType: [],
    categoryType: []
};



export const catalogSlice = createSlice({
    name: "catalog",
    initialState,
    reducers: {
        loadProvince: (state) => {
            state.isProvinceLoading = true;
        },
        loadedProvince: (state, action) => {
            state.isProvinceLoading = false;
            state.province = action.payload;
        },
        loadCanton: (state) => {
            state.isCantonLoading = true;
        },
        loadedCanton: (state, action) => {
            state.isCantonLoading = false;
            state.canton = action.payload;
        },
        loadDistrict: (state) => {
            state.isDistrictLoading = true;
        },
        loadedDistrict: (state, action) => {
            state.isDistrictLoading = false;
            state.district = action.payload;
        },
        loadCustomerType: (state) => {
            state.isCustomerTypeLoading = true;
        },
        loadedCustomerType: (state, action) => {
            state.isCustomerTypeLoading = false;
            state.customerType = action.payload;
        },
        loadCategoryType: (state) => {
            state.isCategoryTypeLoading = true;
        },
        loadedCategoryType: (state, action) => {
            state.isCategoryTypeLoading = false;
            state.categoryType = action.payload;
        }
    },
});
export const catalogSliceActions = catalogSlice.actions;
export default catalogSlice.reducer;
